import { useQuery } from '@tanstack/react-query'
import { graphqlClient } from '@/core/api/graphql-client'
import { DiscoveryItemsDocument } from '@/generated/graphql'

export function useDiscoveryItems() {
  return useQuery({
    queryKey: ['discovery-items'],
    queryFn: () => graphqlClient.request(DiscoveryItemsDocument),
  })
}
